module.exports = __webpack_public_path__ + "media/images/konintodoke/top_mv/konintodoke00008-95b4998a6cf5e7066a3edc741a089141.jpg";